import classNames from 'classnames'
import React from 'react'
import { ROUTE_ITINERARY_HOME } from '../../routes'
import { navigateTo } from '../../store/history/history.actions'
import itineraryIcon from '../genericComponents/assets/itinerary.svg?raw'
import T from '../i18n/T'
import { useAction } from '../utils/react-redux'
import s from './Header.less'

const ItineraryButton = () => {
  const connectedNavigateTo = useAction(navigateTo)
  const goToItinerary = () => {
    connectedNavigateTo({ route: ROUTE_ITINERARY_HOME })
  }

  return (
    <div className={s.mainButton} onClick={goToItinerary}>
      <div className={classNames('icon', s.mainButtonIcon)} dangerouslySetInnerHTML={{ __html: itineraryIcon }}></div>
      <div className={s.mainButtonLabel}>
        <T id={'universes.itineraries'} />
      </div>
    </div>
  )
}

export default ItineraryButton
